import { FormBase } from 'core/components';

export default class ChangeShippingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
		});
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseId',
					label: 'CHANGESHIPPINGVIEW.WAREHOUSE',
				},
				{
					name: 'carrierServiceId',
					label: 'CHANGESHIPPINGVIEW.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'useBuyShipping',
					label: 'CHANGESHIPPINGVIEW.USEBUYSHIPPING',
					type: 'checkbox',
					rules: 'required',
					default: null,
				},
				{
					name: 'voidLabelOptionId',
					label: 'CHANGESHIPPINGVIEW.VOIDLABELOPTION',
				},
				{
					name: 'ignoreDeliverByDate',
					type: 'checkbox',
					label: '',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/ChangeShippingForm.js